import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import type {
  MarketingVideosSlot,
  MarketingVideosSlots,
} from '../../../store/MarketingVideos/MarketingVideos.model';

import {
  Stack,
  HeaderText,
} from '..';

import {
  useFeatureFlagRedux,
  useResponsiveEffect,
} from '../../../hooks';

import {
  MarketingVideo,
} from './MarketingVideo';

import {
  useMarketingVideos,
} from './useMarketingVideos';

import {
  CLIENT_HOMEPAGE_MARKETING_VIDEO_MODULE_FLAG_NAME,
} from './constants';
import { TrackOnMount } from '../../TrackOnMount';

export type MarketingVideosProps = {
  slotName: MarketingVideosSlots;
};

export function MarketingVideos({
  slotName,
}: MarketingVideosProps) {
  const is = useResponsiveEffect();
  const { enabled } = useFeatureFlagRedux(
    CLIENT_HOMEPAGE_MARKETING_VIDEO_MODULE_FLAG_NAME(slotName),
  );
  const videoData: MarketingVideosSlot = useMarketingVideos(slotName);

  if (!(videoData && enabled)) return null;

  const outerPadding = (is.mobile || is.tablet) ? 0 : 32;
  const outerAlignItems = (is.mobile || is.tablet) ? 'flex-start' : 'center';
  const displayVideos = (is.mobile || is.tablet) ? [videoData.videos[0]] : videoData.videos;
  const videoWidth = `${100 / displayVideos.length}%`;

  return (
    <Stack
      paddingY={outerPadding}
      testID="marketing-videos"
      alignItems={outerAlignItems}
    >
      <TrackOnMount event="view" params={{ component: 'MarketingVideos' }} />
      <Box padding={16}>
        <HeaderText level={2}>
          Meet StyleSeat Pros
        </HeaderText>
      </Box>

      <Inline maxWidth="100%">
        {displayVideos.map(video => (
          <React.Fragment key={video.id || video.videoSources?.[0]?.src}>
            <MarketingVideo
              video={video}
              width={videoWidth}
            />
          </React.Fragment>
        ))}
      </Inline>
    </Stack>
  );
}
